module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/maria_off-e4c1a4d9b19dfa0949ee13218aa17b9c.gif";